import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const FullLoader = () => (
  <div className="min-h-screen flex items-center justify-center" data-testid="page-loader">
    <Loader2 className="w-8 h-8 text-rose-500 animate-spin" />
  </div>
);

export default function ProtectedRoute({ children, admin = false }) {
  const { user } = useAuth();
  if (user === null) return <FullLoader />;
  if (user === false) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/feed" replace />;
  return children;
}
